import { render, staticRenderFns } from "./CountryWithPopover.vue?vue&type=template&id=41571d56&scoped=true"
import script from "./CountryWithPopover.vue?vue&type=script&lang=js"
export * from "./CountryWithPopover.vue?vue&type=script&lang=js"
import style0 from "./CountryWithPopover.vue?vue&type=style&index=0&id=41571d56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41571d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41571d56')) {
      api.createRecord('41571d56', component.options)
    } else {
      api.reload('41571d56', component.options)
    }
    module.hot.accept("./CountryWithPopover.vue?vue&type=template&id=41571d56&scoped=true", function () {
      api.rerender('41571d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/CountryWithPopover.vue"
export default component.exports